// extracted by mini-css-extract-plugin
export default {"default":"Button_default__T4n3+","pill":"Button_pill__43gMc"};